import type { RouteLocationAsRelativeGeneric } from 'vue-router'
import { ALLOWED_CIS_COUNTRIES_WITHOUT_DOMAIN } from '~/core/i18n'

export const withRouteParams = (to: RouteLocationAsRelativeGeneric) => {
  const route = useRoute()
  const { country } = route.params

  if (typeof country !== 'string') {
    return to
  }

  return {
    ...to,
    params: {
      ...to.params,
      country: ALLOWED_CIS_COUNTRIES_WITHOUT_DOMAIN.find(iso => iso === country.toUpperCase()) ? country : '',
    },
  }
}
